import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import { STEPS } from '@/shared/constants';
import { WorkflowService } from '@/shared/WorkflowService';

export const MenuItemNewRepeatedCourse = (props: {
  course: ICourse,
  onNewRepeatedCourse: (course: ICourse) => void;
}) => {
  const isDisabled = !(WorkflowService.getModuleIdFromStep(props.course.CourseStep) === STEPS.REVIEW || WorkflowService.isCourseCompleted(props.course.CourseStep));
  return <MenuItem isDisabled={isDisabled} icon={<FiPlus />} onClick={() => props.onNewRepeatedCourse(props.course)} >New Repeated Course...</MenuItem>
}
